import { BlogsCollection } from "./BlogsCollection"
import BlogsLists from "./BlogsLists"

const NordenBlogMain = () => {
   return (
      <>
         <BlogsLists />
         <BlogsCollection />
      </>
   )
}

export default NordenBlogMain
